module.exports = __webpack_public_path__ + "static/media/globe.eca1a229.svg";